import DataModule from "@/components/DataModule";

export default function Suppliers() {
  return (
    <DataModule
      title="Suppliers"
      subtitle="Vendors and supplier ledger"
      endpoint="suppliers"
      pageTestId="suppliers-page"
      fields={[
        { key: "name", label: "Supplier Name", required: true },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email", type: "email" },
        { key: "gst_number", label: "GST Number" },
        { key: "pan_number", label: "PAN" },
        { key: "address", label: "Address", type: "textarea", full: true },
        { key: "bank_name", label: "Bank Name" },
        { key: "account_number", label: "Account No." },
        { key: "ifsc", label: "IFSC" },
        { key: "opening_balance", label: "Opening Balance", type: "number", default: 0 },
      ]}
      columns={[
        { key: "name", label: "Name", render: (s) => <span className="font-medium">{s.name}</span> },
        { key: "phone", label: "Phone" },
        { key: "gst_number", label: "GST" },
        { key: "bank_name", label: "Bank" },
      ]}
    />
  );
}
